module.exports = __webpack_public_path__ + "img/img-sintesis.8863aeee.png";